import { Copyright } from 'components/atoms';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

type Props = {
  isAuthPage?: boolean;
};

export default function Footer({ isAuthPage = false }: Props) {
  const { t } = useTranslation('common');

  const navItems = [
    {
      name: t('login'),
      to: '/login',
      isHidden: !isAuthPage,
    },
    {
      name: t('online-help'),
      to: '/help',
      isHidden: !isAuthPage,
    },
    {
      name: t('contact-us'),
      to: isAuthPage ? '/contact' : '/common/contact',
      isHidden: false,
    },
    {
      name: t('get-info'),
      to: isAuthPage ? '/get-info' : '/common/get-info',
      isHidden: false,
    },
    {
      name: t('kvkk'),
      to: isAuthPage ? '/kvkk' : '/common/kvkk',
      isHidden: false,
    },
    {
      name: t('faq-abbr'),
      to: isAuthPage ? '/faq' : '/common/faq',
      isHidden: false,
    },
  ];

  return (
    <footer className="mt-auto flex w-full flex-col-reverse items-center justify-between gap-2 rounded-t-lg bg-neutral-0 px-2 py-4 text-center text-body16 shadow-sm xs:gap-4 md:flex-row md:px-9">
      <Copyright />

      <nav>
        {navItems
          .filter((item) => !item.isHidden)
          .map((item, idx) => (
            <Fragment key={item.name}>
              {idx > 0 && <span className="px-4 text-neutral-400">|</span>}

              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? 'pointer-events-none cursor-default font-medium text-primary-500'
                    : 'text-neutral-400 hover:underline'
                }
              >
                {item.name}
              </NavLink>
            </Fragment>
          ))}
      </nav>
    </footer>
  );
}

